export default __webpack_public_path__ + "static/media/iso_date.53b381d5.svg";